module.exports = __webpack_public_path__ + "static/media/icon_data-resolve.24e8a25b.svg";